import { apiInstances } from '../../../../libs';

const { post } = apiInstances.orderInstance;

export default async function confirmPickupFromConsumer({ idOrder, payload }) {
  return await post(
    `/clouders/orders/${idOrder}/pickup-from-consumer`,
    payload
  );
}
